import { Injectable } from '@angular/core';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { RouteIds, Step } from '../../types';
import { StepDefinitionStrategy } from './step-definition.strategy';

/**
 * Step definition service for the Build Your Course step
 */
@Injectable({
  providedIn: 'root',
})
export class BuildYourCourseStepDefinitionService implements StepDefinitionStrategy {
  getStepDefinition(): Step {
    return {
      id: RouteIds.buildYourCourse,
      title: $localize`1. Build Your course`,
      nextStep: () => RouteIds.yourInformation,
      googleAnalyticsEvent: GoogleAnalyticsEventEnum.BuildYourCourse,
      shareableDeeplink: true,
    };
  }
}
